module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/white_ant_check.2db6a9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/phone/product/white_ant_check.jpg
// module id = 4cqG
// module chunks = 0